<template>
    <v-container grid-list-lg px-5 class="pb-big">
        <h2 class="title-text-cards">Projects</h2>
        <p class="sub-title-text-cards">
            Below are some of the projects in discovery or being built.
        </p>
        <v-layout row wrap class="meal-plans">
            <!-- <template v-for="(item, index) in items">
                <v-flex xs12 sm12 md3 :key="index">
                    <v-card class="rounded-card">
                        <v-responsive>
                            <v-img
                                :src="require('../assets/img/1.png')"
                                height="183px"
                            >
                                <v-container fill-height fluid>
                                    <v-layout fill-height>
                                        <v-flex xs12 align-end flexbox>
                                            <span class="">{{ item.cat }}</span>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-img>
                        </v-responsive>

                        <v-card-text>
                            <div>
                                <h3 class=" mb-2">{{ item.title }}</h3>
                                <div>{{ item.text }}</div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </template> -->
            <v-flex xs12 sm12 md3>
                <v-hover>
                    <v-card class="rounded-card">
                        <v-img
                            :src="
                                require('../assets/img/CardProjectAthena.jpg')
                            "
                            height="400px"
                        >
                            <v-responsive>
                                <v-container fill-height fluid>
                                    <v-layout fill-height>
                                        <v-flex xs12 align-end flexbox>
                                            <span class="white--text"
                                                >Prediction Model</span
                                            >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-responsive>

                            <v-card-text class="rounded-card-text-1">
                                <div>
                                    <h4 class="rounded-custom-text-1 mb-2">
                                        Prediction Model
                                    </h4>
                                    <br /><br />
                                    <h3 class="color-blue">Epidemic Model</h3>
                                    <br />
                                    <div>
                                        SIR/SEIR models are used to simulate
                                        virus outbreaks. We aim at estimating
                                        their parameters and using them for long
                                        term predictions
                                    </div>
                                </div>
                            </v-card-text>
                        </v-img>
                    </v-card>
                </v-hover>
            </v-flex>
            <v-flex xs12 sm12 md3>
                <v-card class="rounded-card">
                    <v-img
                        :src="require('../assets/img/CardProjectAthena.jpg')"
                        height="400px"
                    >
                        <v-responsive>
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="white--text">
                                            Diagnosis
                                        </span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-responsive>

                        <v-card-text
                            class="rounded-card-text-2"
                            style="overflow-y: hidden !important"
                        >
                            <div>
                                <h4 class="rounded-custom-text-2 mb-2">
                                    Diagnosis
                                </h4>
                                <br /><br />
                                <h3 class="color-blue">Breathing Sounds</h3>
                                <br />
                                <div>
                                    We aim to use mobile devices and a telephone
                                    chat bot to record breathing sounds and
                                    identify change points in these sounds that
                                    indicate a worsening of an infected person.
                                </div>
                            </div>
                        </v-card-text>
                    </v-img>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md3>
                <v-card class="rounded-card">
                    <v-img
                        :src="require('../assets/img/CardProjectAthena.jpg')"
                        height="400px"
                    >
                        <v-responsive>
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="white--text">Data</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-responsive>

                        <v-card-text class="rounded-card-text-3">
                            <div>
                                <h4 class="rounded-custom-text-3 mb-2">Data</h4>
                                <br /><br />
                                <h3 class="color-blue">
                                    Unified Data Pipeline
                                </h3>
                                <br />
                                <div>
                                    We build a data pipeline that acquires data
                                    from multiple sources, combines and
                                    aggregates them and provides high quality
                                    data to the public.
                                </div>
                            </div>
                        </v-card-text>
                    </v-img>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md3>
                <v-card class="rounded-card">
                    <v-img
                        :src="require('../assets/img/CardProjectAthena.jpg')"
                        height="400px"
                    >
                        <v-responsive>
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="white--text">Data</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-responsive>

                        <v-card-text class="rounded-card-text-4">
                            <div>
                                <h4 class="mb-2 rounded-custom-text-4">
                                    Ideate
                                </h4>
                                <br /><br />
                                <h3 class="color-blue">Postulate hypothesis</h3>
                                <br />
                                <div>
                                    Collect hypothesis and product ideas from
                                    volunteers, and evaluate them as a
                                    community.
                                </div>
                            </div>
                        </v-card-text>
                    </v-img>
                </v-card>
            </v-flex>
            <div v-show="$route.name !== 'projects'">
                <v-btn class="btn-view-all-projects" href="/projects">
                    View all projects
                </v-btn>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'HomeProjects',
    data() {
        return {
            items: [
                {
                    img: '../assets/img/1.png',
                    title: 'Epidemic model',
                    category: 'Prediction Model',
                    text: ''
                },
                {
                    img: '../assets/img/1.png',
                    title: 'Breathing Sounds',
                    category: 'Diagnosis',
                    text:
                        'We aim to use mobile devices and a telephone chat bot to record breathing sounds and identify change points in these sounds that indicate a worsening of an infected person.'
                },
                {
                    img: '../assets/img/1.png',
                    title: 'Unified data pipeline',
                    category: 'Data',
                    text: ''
                },
                {
                    img: '../assets/img/1.png',
                    title: 'Corona Poll',
                    category: 'Data',
                    text: ''
                }
            ]
        };
    },
    methods: {}
};
</script>

<style scoped></style>
